import { TFunction } from 'i18next';
import { formatDateWithLetterMonth } from './date.utils';

interface GetPdfFooterCopyrightTextProps {
  t: TFunction<undefined>;
  date?: string;
  id?: string;
  licensePlateNumber?: string;
  vin?: string;
}

export const getPdfFooterCopyrightText = ({
  t,
  date,
  id,
  licensePlateNumber,
  vin,
}: GetPdfFooterCopyrightTextProps) => {
  let text = `© Lucius ${new Date().getFullYear()} - By Trustoo | ${t('common:inspectionOf')} ${formatDateWithLetterMonth(
    {
      dateString: new Date(date).toDateString(),
      monthAbbreviated: false,
    },
  )}`;

  if (!licensePlateNumber && !vin) {
    text += ` | N° ${id}`;
  }

  if (licensePlateNumber || vin) {
    text += `\nN° ${id} ${
      licensePlateNumber
        ? ` | ${t('common:licensePlateNumber')} : ${licensePlateNumber}`
        : ''
    } ${vin ? ` | ${t('common:vin')} : ${vin}` : ''}`;
  }

  return text;
};
